import { shallowMount } from "@vue/test-utils";
import NotificationToast from "@/components/core/NotificationToast";

describe("NotificationToast component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(NotificationToast);
  });

  it("Renders del component NotificationToast", () => {
    expect(wrapper).toBeDefined();
  });
});
